var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H10.8284C10.298 2 9.78929 2.21071 9.41421 2.58579L5.58579 6.41421C5.21071 6.78929 5 7.29799 5 7.82843V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2ZM9 11H11.25V14.25H8V12C8 11.4477 8.44771 11 9 11ZM8 18V15.75H11.25V19H9C8.44771 19 8 18.5523 8 18ZM12.75 19V15.75H16V18C16 18.5523 15.5523 19 15 19H12.75ZM16 12V14.25H12.75V11H15C15.5523 11 16 11.4477 16 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimCard);
export default __webpack_public_path__ + "static/media/sim-card.8f75528bba34849e9313b847afeeb414.svg";
export { ForwardRef as ReactComponent };